import { inject } from '@angular/core';
import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { throwError } from 'rxjs';
import { config } from '../../../environments/environment';
import { ApiCompatibilityService } from '../services/api-compatibility.service';

export const apiCompatibilityInterceptor: HttpInterceptorFn = (request, next) => {
  if (!config.backendUrl) return next(request);
  const compatibility = inject(ApiCompatibilityService);
  const url = new URL(request.url, location.href);
  if (
    url.origin === new URL(config.backendUrl, location.href).origin &&
    url.pathname.startsWith('/v1/') &&
    url.pathname !== '/v1/maintenance' &&
    compatibility.unsupported()
  ) {
    return throwError(
      () =>
        new HttpErrorResponse({
          status: 409,
          error: {
            code: 'INCOMPATIBLE_API',
            message: 'This app needs an update to work with the server.',
          },
        })
    );
  }
  return next(request);
};
